import React from "react";
import { Form } from "formik";
import InternationalFields from '../International/InternationalFields';

const InternationalStep = ({ model }) => (
    <Form className="international-form">
        <InternationalFields model={model} />
    </Form>
);

export default InternationalStep;